import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-premiere-pro/uxp-premiere-pro/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "utils"
    }}>{`Utils`}</h1>
    <h2 {...{
      "id": "static-methods"
    }}>{`Static Methods`}</h2>
    <h3 {...{
      "id": "isaeinstalled"
    }}>{`isAEInstalled`}</h3>
    <span className="minversion" style={{
      "display": "block",
      "marginBottom": "-1em",
      "marginLeft": "36em",
      "cssFloat": "left",
      "opacity": "0.5"
    }}>25.0</span>
    <p><em parentName="p">{`boolean`}</em></p>
    <p>{`Check if AE is installed.`}</p>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      